import { useEffect } from "react";
import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { isFirebaseConfigured } from "@/lib/firebase";
import Layout from "@/components/Layout";
import LoginGate from "@/components/LoginGate";
import ProofView from "@/pages/ProofView";
import SetupGate from "@/components/SetupGate";
import AdminHome from "@/pages/admin/AdminHome";
import ImportStudents from "@/pages/admin/ImportStudents";
import StudentsPage from "@/pages/admin/StudentsPage";
import AddressUpdates from "@/pages/admin/AddressUpdates";
import AddressReview from "@/pages/admin/AddressReview";
import AddressConfirm from "@/pages/admin/AddressConfirm";
import LoadingLists from "@/pages/admin/LoadingLists";
import CourierList from "@/pages/admin/CourierList";
import DriversStats from "@/pages/admin/DriversStats";
import AssignDongs from "@/pages/admin/AssignDongs";
import UserRoles from "@/pages/admin/UserRoles";
import MissionControl from "@/pages/admin/MissionControl";
import AgentChat from "@/pages/admin/AgentChat";
import PricingSimulator from "@/pages/admin/PricingSimulator";
import InventoryPage from "@/pages/admin/InventoryPage";
import ApartmentsPage from "@/pages/admin/ApartmentsPage";
import Bootstrap from "@/pages/Bootstrap";
import Onboarding from "@/pages/Onboarding";
import OrgSettings from "@/pages/admin/OrgSettings";
import Billing from "@/pages/admin/Billing";
import Welcome from "@/pages/Welcome";
import Join from "@/pages/Join";
import DriverHome from "@/pages/driver/DriverHome";
import ClaimDongs from "@/pages/driver/ClaimDongs";
import RouteDay from "@/pages/driver/RouteDay";
import DeliveryDetail from "@/pages/driver/DeliveryDetail";
import MyStats from "@/pages/driver/MyStats";
import ApartmentView from "@/pages/driver/ApartmentView";

export default function App() {
  const { init, user, role, loading } = useAuth();
  const loc = useLocation();
  useEffect(() => init(), [init]);

  if (!isFirebaseConfigured) return <SetupGate />;

  // 보호자용 공개 사진 페이지 — 로그인 없이 접근
  if (loc.pathname.startsWith("/p/")) {
    return (
      <Routes>
        <Route path="/p/:code" element={<ProofView />} />
      </Routes>
    );
  }

  if (loading) return <div className="p-8 text-center text-slate-500">로딩 중…</div>;
  if (!user) return <LoginGate />;

  // 역할이 없는 새 계정 — 업체 만들기·초대 링크·(최초 운영자용) 부트스트랩만 열고 나머지는 환영 화면
  if (!role) {
    return (
      <Routes>
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/join/:code" element={<Join />} />
        <Route path="/bootstrap" element={<Layout><Bootstrap /></Layout>} />
        <Route path="*" element={<Welcome />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={role === "admin" ? "/admin" : "/driver"} replace />} />

        {/* 관리자 — 역할로 막는다. 메뉴만 숨기면 기사가 주소창에 /admin/students를 쳐서 명단을 내려받는다(4차 점검 11) */}
        <Route element={role === "admin" ? <Outlet /> : <Navigate to="/driver" replace />}>
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/mission" element={<MissionControl />} />
        <Route path="/admin/agent" element={<AgentChat />} />
        <Route path="/admin/import" element={<ImportStudents />} />
        <Route path="/admin/students" element={<StudentsPage />} />
        <Route path="/admin/address-updates" element={<AddressUpdates />} />
        <Route path="/admin/address-review" element={<AddressReview />} />
        <Route path="/admin/address-confirm" element={<AddressConfirm />} />
        <Route path="/admin/loading-lists" element={<LoadingLists />} />
        <Route path="/admin/courier" element={<CourierList />} />
        <Route path="/admin/drivers" element={<DriversStats />} />
        <Route path="/admin/assign" element={<AssignDongs />} />
        <Route path="/admin/users" element={<UserRoles />} />
        <Route path="/admin/pricing" element={<PricingSimulator />} />
        <Route path="/admin/inventory" element={<InventoryPage />} />
        <Route path="/admin/apartments" element={<ApartmentsPage />} />
        <Route path="/admin/org" element={<OrgSettings />} />
        <Route path="/admin/billing" element={<Billing />} />
        </Route>

        {/* 최초 세팅용 */}
        <Route path="/bootstrap" element={<Bootstrap />} />
        {/* 신규 업체 온보딩 */}
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/join/:code" element={<Join />} />

        {/* 기사 */}
        <Route path="/driver" element={<DriverHome />} />
        <Route path="/driver/claim" element={<ClaimDongs />} />
        <Route path="/driver/route" element={<RouteDay />} />
        <Route path="/driver/route/:studentId" element={<DeliveryDetail />} />
        <Route path="/driver/apartment/:buildingKey" element={<ApartmentView />} />
        <Route path="/driver/stats" element={<MyStats />} />

        <Route path="*" element={<div className="p-8">페이지 없음</div>} />
      </Routes>
    </Layout>
  );
}
